/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SectorInputs */

const en_sector = /** @type {(inputs: SectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sector`)
};

const de_sector = /** @type {(inputs: SectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branche`)
};

/**
* | output |
* | --- |
* | "Sector" |
*
* @param {SectorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sector = /** @type {((inputs?: SectorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SectorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sector(inputs)
	return en_sector(inputs)
});